export const maskFilter = (value, {
    showStart = 0,
    showEnd = 0,
    maskChar = '●',
} = {}) => {
    if (!value) {
        return '';
    }

    const str = String(value);
    const len = str.length;

    showStart = Math.min(showStart, len);
    showEnd = Math.min(showEnd, len - showStart);

    const start = str.slice(0, showStart);
    const end = str.slice(len - showEnd);
    const maskLen = len - showStart - showEnd;
    const mask = maskChar.repeat(maskLen);

    return start + mask + end;
};
